var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.defaultContainer
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              !_vm.coLoader
                ? [
                    _vm._l(_vm.source, function(item, index) {
                      return [_vm._t("default", null, { data: item })]
                    })
                  ]
                : [_vm._t("loader")]
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "row wrap" },
            [
              !_vm.coLoader
                ? [
                    _vm._l(_vm.source, function(item, index) {
                      return [_vm._t("default", null, { data: item })]
                    })
                  ]
                : [_vm._t("loader")]
            ],
            2
          ),
      _vm._v(" "),
      _vm.visible
        ? _c("v-infinite-loading", {
            ref: "infiniteLoading",
            on: { infinite: _vm.handleInfiniteLoading }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea8e7ab0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea8e7ab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/infinity-loading/template.html
// module id = null
// module chunks = 